<div #timeCF class="pointCF__field">
  <label class="pointCF__label">
    <div class="pointCF__label-image--container">
      <pp-icon [ppSrc]="EIconPath.ICON_FIELDS_TIME_18" ppColor="inherit" ppClass="setSize18" />
    </div>

    <span
      ppTooltip
      class="pointCF__label-container"
      ppTitle="{{ ppFieldLabel }}"
      [ppTrimTooltip]="true"
    >
      {{ ppFieldLabel }}
    </span>

    @if (ppFieldDescription) {
      <pp-point-fields-custom-field-description
        [ppDescription]="ppFieldDescription"
      ></pp-point-fields-custom-field-description>
    }
  </label>

  <div class="pointCF__content pointCF__content--time" [class.disableField]="ppIsLocked">
    <section
      class="time__content__left"
      ppTooltip
      [ppTitle]="ppIsLocked ? ('locked_by_admin' | ppTranslate) : null"
    >
      <pp-time-input
        class="time__input"
        [ppCanEdit]="ppCanEdit"
        [ppShowHoursOnly]="showHoursOnly"
        (ppOnModelChange)="onModelChange()"
        [(ppValue)]="newValue"
        (ppUpdate)="setNewValue($event)"
        [ppClearObservable]="clearObservable$"
        (ppSave)="updateField()"
        [ppIsLocked]="ppIsLocked"
      />

      <div class="iconWrapper">
        @if (ppCanEdit) {
          <pp-icon
            class="time_save_button"
            [class.disabled]="ppIsLocked"
            ppClass="setSize32"
            [ppSrc]="EIconPath.ICON_INPUT_SQUARE_PLUS_32"
            [ppDisplayContents]="true"
            [ppColor]="ppIsLocked ? 'grey-300' : this.newValue ? 'primary-600' : 'grey-400'"
            [ppHoverColor]="!ppIsLocked ? (this.newValue ? 'primary-600' : 'grey-600') : null"
            (click)="updateField()"
          />
        }
        @if (ppIsLocked) {
          <pp-padlock-icon />
        }
      </div>
    </section>

    <div class="time_total">
      <span class="pointCF__label--total"> {{ 'total' | ppTranslate }}: </span>

      <span class="totalNumber">
        @if (!showHoursOnly) {
          {{ +value < 0 ? '-' : '' }}{{ displayDays }}d / {{ displayHours < 10 ? '0' : ''
          }}{{ displayHours }}:{{ displayMinutes < 10 ? '0' : '' }}{{ displayMinutes }}
        }

        @if (showHoursOnly) {
          {{ +value < 0 ? '-' : '' }}{{ displayDays * 24 + displayHours < 10 ? '0' : ''
          }}{{ displayDays * 24 + displayHours }}:{{ displayMinutes < 10 ? '0' : ''
          }}{{ displayMinutes }}
        }
      </span>
    </div>
  </div>
</div>
